var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreate = function SvgCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8 1-.5-1L7 1l-1 .125.834.708L6.5 3l1-.666L8.5 3l-.334-1.167L9 1.125zm8.334 10.666L15.5 10l-.834 1.666-1.666.209 1.39 1.181L13.833 15l1.666-1.111L17.166 15l-.555-1.944 1.39-1.181zM3.667 3.333 3 2l-.667 1.333L1 3.5l1.111.944L1.667 6 3 5.111 4.333 6 3.89 4.444 5 3.5zM.414 14c0 .534.208 1.036.586 1.414L2.586 17c.378.378.88.586 1.414.586s1.036-.208 1.414-.586L17 5.414c.378-.378.586-.88.586-1.414S17.378 2.964 17 2.586L15.414 1c-.756-.756-2.072-.756-2.828 0L1 12.586c-.378.378-.586.88-.586 1.414M14 2.414 15.586 4 12 7.586 10.414 6z"
  })));
};
export default SvgCreate;